let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aD0sx")).then(() => parcelRequire('fB17y'));